import { TextField, Autocomplete, Box } from "@mui/material";

export const SearchBar = ({
  allDataSearch,
  isPatientComponent,
  handleChange,
  findSelected,
  contentTitles,
  placeholder
}) => {

  return (
    <>
      {allDataSearch && (
        <>
          <Autocomplete
            component='select'
            onChange={handleChange}
            value={findSelected}
            isOptionEqualToValue={(option, value) => {
              if (value.id) {
                return option.id === value.id;
              }
              return true;
            }}
            id='dataSearch-select'
            data-cy='autocomplete-dataSearch-select'
            options={isPatientComponent ? allDataSearch : contentTitles}
            autoHighlight
            getOptionLabel={(option) => isPatientComponent ? (option.fullName || "") : (option || "")}
            renderInput={(params) => (
              <>
                <TextField
                  {...params}
                  fullWidth
                  variant='outlined'
                  label={"Participante"}
                  placeholder={placeholder}
                  sx={{
                    bgcolor: "white",
                    borderRadius: 3,
                    fontSize: 20,
                    boxShadow: 2,
                  }}
                />
              </>
            )}
          >
          </Autocomplete>
        </>
      )}
    </>
  );
};
